import { render, staticRenderFns } from "./CaseSingle.vue?vue&type=template&id=5b443567&scoped=true&"
import script from "./CaseSingle.vue?vue&type=script&lang=js&"
export * from "./CaseSingle.vue?vue&type=script&lang=js&"
import style0 from "./CaseSingle.vue?vue&type=style&index=0&id=5b443567&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b443567",
  null
  
)

export default component.exports